
import { Button } from "@/components/ui/button";
import { ArrowRight, Calendar } from "lucide-react";
import { Link } from "react-router-dom";

export const HeroSection = () => {
  return (
    <section className="relative pt-32 pb-20 md:pt-40 md:pb-32 overflow-hidden">
      <div className="absolute inset-0 bg-dental-offwhite z-0">
        <div className="absolute inset-0 opacity-50" style={{
          backgroundImage: 'radial-gradient(#6B7D6A 0.5px, transparent 0.5px)',
          backgroundSize: '30px 30px'
        }}></div>
      </div>
      
      <div className="absolute top-1/2 -right-64 w-[500px] h-[500px] rounded-full bg-dental-highlight opacity-5 blur-3xl"></div>
      <div className="absolute bottom-1/2 -left-96 w-[600px] h-[600px] rounded-full bg-dental-accent opacity-5 blur-3xl"></div>
      
      <div className="container-custom relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1 animate-fade-in-up">
            <span className="inline-block text-dental-highlight font-medium mb-4 uppercase tracking-wider text-sm">
              Welcome to Asrani Dental Clinic - Since 1986
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-semibold mb-6 leading-tight">
              Best Dentist in Nagpur – Asrani Dental Clinic, Sadar
            </h1>
            <p className="text-lg text-dental-muted mb-8 max-w-lg">
              Asrani Dental is a trusted name when people search for the best dentist in Nagpur. Located in the heart of Sadar, our clinic is loved by families across Nagpur. From painless root canals to cosmetic smile makeovers, we offer every treatment under one roof. Parents often say we're the <Link to="/services/pediatric-dentistry-in-nagpur" className="text-dental-highlight hover:underline">best kids dental clinic in Nagpur Sadar</Link> because we offer a calm and fun environment for children.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button className="btn-primary flex items-center text-base group" asChild>
                <Link to="/dental-appointment-booking">
                  <Calendar size={18} className="mr-2 transition-transform duration-300 group-hover:scale-110" />
                  Book Appointment
                </Link>
              </Button>
              <Button className="btn-primary flex items-center text-base group" asChild>
                <Link to="/about">
                  Learn More
                  <ArrowRight size={18} className="ml-2 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
            
            <div className="mt-10 flex items-center">
              <a onClick={(e) => { e.preventDefault(); (window as any).gtag_report_conversion && (window as any).gtag_report_conversion("tel:+918010224989"); }} href="tel:+918010224989" className="flex items-center text-dental-highlight font-medium hover:text-dental-accent transition-colors duration-300">
                <div className="w-12 h-12 rounded-full bg-dental-highlight/10 flex items-center justify-center mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-dental-highlight"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                </div>
                <span className="text-lg">+91 8010224989</span>
              </a>
            </div>
          </div>
          
          <div className="order-1 lg:order-2 relative animate-fade-in">
            <div className="relative">
              <div className="w-full h-full absolute -top-6 -right-6 rounded-2xl border-2 border-dental-accent/20"></div>
              <img src="/lovable-uploads/a8dde84d-dc06-401a-b0d9-f466999fd073.png" alt="Dr. Hemant Asrani best dentist in Nagpur" className="w-full h-auto rounded-2xl shadow-soft" loading="eager" width="600" height="400" />
              <div className="absolute -bottom-10 -left-5 sm:-left-10 w-24 h-24 sm:w-28 sm:h-28 md:w-40 md:h-40 bg-white p-3 sm:p-4 rounded-xl shadow-soft flex flex-col items-center justify-center animate-fade-in-up z-10">
                <span className="text-base sm:text-lg md:text-xl font-serif font-bold text-dental-highlight mb-1">4.9★</span>
                <span className="text-xxs sm:text-xs md:text-sm text-dental-muted text-center">300+ Google Reviews</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
